import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const breadcrumbItems = [
    { label: '首页', path: '/' },
    { label: '关于我们' },
  ];

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotInput = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotInput && honeypotInput.value.trim() !== '') {
      setFormStatus('success');
      form.reset();
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const formData = new FormData(form);
      if (honeypotInput) {
        formData.delete('phone_alt');
      }

      const response = await fetch('https://readdy.ai/api/form/d9s941knlsngrm4lmifg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '';

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 3000);
      } else {
        setFormError(serverMsg || '提交失败，请稍后重试');
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  const testimonials = [
    {
      name: '张女士',
      role: 'App重度用户',
      content: '通过这个网站找到了很多优质的美女视频App，推荐的内容质量非常高。现在每天都要刷一刷推荐的美女短视频，已经成为我的日常习惯了。',
      rating: 5,
    },
    {
      name: '李先生',
      role: '短视频爱好者',
      content: '网站的评测文章非常专业详细，帮助我选到了最适合自己的美女视频App。分类清晰，内容更新及时，强烈推荐给所有喜欢看美女短视频的朋友。',
      rating: 5,
    },
    {
      name: '王小姐',
      role: '颜值主播',
      content: '作为平台上的主播，我非常感谢这个推荐网站。很多粉丝都是通过这里了解到我的直播间的。网站的入驻指南对新人也很有帮助。',
      rating: 5,
    },
    {
      name: '刘先生',
      role: '科技博主',
      content: '从专业角度来说，这个网站的美女视频App评测非常全面客观。画质、流畅度、内容丰富度等维度都有详细的对比分析，值得信赖。',
      rating: 5,
    },
    {
      name: '陈女士',
      role: '时尚达人',
      content: '穿搭分类的内容特别棒！学到了很多实用的搭配技巧。网站的界面也很清爽，浏览体验非常好。已经推荐给了身边的朋友。',
      rating: 4,
    },
    {
      name: '赵先生',
      role: '普通用户',
      content: '下载推荐的美女视频App后确实很好用，高清画质、流畅播放，内容也很丰富。新用户福利也真实有效，体验感很好。',
      rating: 5,
    },
  ];

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 美女视频推荐',
    description: '美女视频推荐致力于为用户提供最优质的美女视频App推荐和深度评测内容。',
    url: 'https://pozino.cn/about',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '美女视频推荐',
    url: 'https://pozino.cn',
    description: '专注于美女视频App推荐与评测的内容平台，提供海量高清美女短视频资源推荐。',
    email: 'contact@pozino.cn',
    telephone: '400-888-8888',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '建国路88号',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
    foundingDate: '2023',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <div className="pt-16">
          {/* Page Header */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <Breadcrumb items={breadcrumbItems} />
              <div className="mt-4">
                <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
                  关于我们
                </h1>
                <p className="text-foreground-500 text-sm md:text-base max-w-2xl">
                  了解美女视频推荐背后的故事与使命
                </p>
              </div>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-5xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
                <div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-5">
                    品牌故事
                  </h2>
                  <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                    <p>
                      美女视频推荐成立于2023年，是国内领先的美女短视频App推荐平台。我们的使命是帮助用户在海量的短视频应用中，找到最适合自己的那款美女视频App。
                    </p>
                    <p>
                      我们的编辑团队由资深的移动互联网从业者和短视频内容创作者组成，每一位成员都对美女短视频内容有着深厚的理解和热爱。我们坚持独立、客观、专业的评测标准，从画质清晰度、内容丰富度、用户体验、更新频率、社交互动等多个维度进行综合评估。
                    </p>
                    <p>
                      截至目前，我们已经累计评测超过200款美女视频相关App，发布了数百篇深度评测文章和教程指南，帮助超过百万用户找到了心仪的美女短视频平台。
                    </p>
                    <p>
                      我们相信，好的内容值得被更多人看到。无论是才华横溢的颜值主播，还是精心制作的美女短视频，都应该获得应有的关注和认可。美女视频推荐致力于搭建用户与优质内容之间的桥梁。
                    </p>
                  </div>
                </div>
                <div className="aspect-[4/3] rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20team%20of%20young%20Asian%20professionals%20collaborating%2C%20warm%20natural%20light%2C%20minimalist%20design%2C%20cream%20and%20beige%20interior%2C%20editorial%20corporate%20photography&width=800&height=600&seq=about-brand-story&orientation=landscape"
                    alt="美女视频推荐团队"
                    title="美女视频推荐 - 品牌故事"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Core Values */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-5xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                  核心价值观
                </h2>
                <p className="text-foreground-500 text-sm">驱动我们不断前进的信念</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
                {[
                  { icon: 'ri-shield-check-line', title: '客观公正', desc: '坚持独立评测，不接受付费排名，确保每一条推荐的公正性' },
                  { icon: 'ri-star-line', title: '品质优先', desc: '严格筛选推荐内容，只推荐经过实测验证的优质App和内容' },
                  { icon: 'ri-user-heart-line', title: '用户至上', desc: '以用户需求为导向，持续优化推荐算法和内容质量' },
                  { icon: 'ri-lightbulb-line', title: '创新驱动', desc: '不断探索新的评测方法和内容形式，保持行业领先' },
                ].map((value, index) => (
                  <div key={index} className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className={`${value.icon} text-xl`}></i>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-sm">{value.title}</h3>
                    <p className="text-foreground-500 text-xs leading-relaxed">{value.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Testimonials / Reputation */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-5xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                  用户口碑
                </h2>
                <p className="text-foreground-500 text-sm">听听用户怎么说</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {testimonials.map((t, index) => (
                  <div key={index} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-sm ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-foreground-600 text-sm leading-relaxed mb-4">{t.content}</p>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-primary-200 flex items-center justify-center text-primary-700 font-semibold text-sm">
                        {t.name.charAt(0)}
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                        <p className="text-xs text-foreground-400">{t.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact Form */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                  联系我们
                </h2>
                <p className="text-foreground-500 text-sm">有任何问题或建议，欢迎随时联系我们</p>
              </div>

              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70"
              >
                <div className="flex flex-col gap-5">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-2">
                        姓名 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        placeholder="请输入您的姓名"
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-2">
                        邮箱 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        placeholder="请输入您的邮箱"
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-2">
                      主题 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="contact-subject"
                      name="subject"
                      type="text"
                      required
                      placeholder="请输入咨询主题"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-2">
                      留言内容 <span className="text-primary-500">*</span>
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      rows={5}
                      maxLength={500}
                      placeholder="请输入您的留言内容（500字以内）"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    ></textarea>
                  </div>

                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="contact-form-hp"
                  />

                  <button
                    type="submit"
                    disabled={formStatus === 'loading'}
                    className="w-full py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm transition-all hover:bg-primary-600 disabled:opacity-60 cursor-pointer whitespace-nowrap"
                  >
                    {formStatus === 'loading' ? '提交中...' : '发送留言'}
                  </button>

                  {formStatus === 'success' && (
                    <div className="text-center py-3 bg-accent-100 text-accent-800 rounded-lg text-sm">
                      <i className="ri-check-line mr-1"></i>
                      感谢您的留言！我们会尽快回复您。
                    </div>
                  )}

                  {formStatus === 'error' && formError && (
                    <div className="text-center py-3 bg-primary-100 text-primary-700 rounded-lg text-sm">
                      <i className="ri-error-warning-line mr-1"></i>
                      {formError}
                    </div>
                  )}
                </div>
              </form>

              {/* Contact Info */}
              <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
                {[
                  { icon: 'ri-mail-line', title: '电子邮箱', value: 'contact@pozino.cn' },
                  { icon: 'ri-phone-line', title: '联系电话', value: '400-888-8888' },
                  { icon: 'ri-map-pin-line', title: '公司地址', value: '北京市朝阳区建国路88号' },
                ].map((info, index) => (
                  <div key={index} className="text-center p-5 bg-background-50 rounded-xl border border-background-200/70">
                    <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className={`${info.icon} text-lg`}></i>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-800 mb-1">{info.title}</h3>
                    <p className="text-xs text-foreground-500">{info.value}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}